export const isExpression = (value: string) => value.startsWith('=');
